module.exports = __webpack_public_path__ + "img/sodimac.4d0eb4e8.svg";